import React from 'react';
import RichText from './richText';
import Line from './Line';
import { P } from './TahoraUI/Typography';

const PriceGrid = ({ features, allPriceInfo }) => {
  const section1 = allPriceInfo.section1_header[0].text;
  const section2 = allPriceInfo.section2_header[0].text;
  const section3 = allPriceInfo.section3_header[0].text;
  const section4 = allPriceInfo.section4_header[0].text;
  const section5 = allPriceInfo.section5_header[0].text;
  const section6 = allPriceInfo.section6_header[0].text;

  return (
    <tbody class="border-t border-gray-200 divide-y divide-gray-200">
      <tr>
        <th
          class=" py-3 pl-6 text-sm font-medium text-gray-900 text-left"
          colspan="1"
          scope="colgroup"
        >
          <div
            class="para"
            style={{
              fontFamily: 'Inter600',
              color: 'black',
              fontSize: '18px',
              fontWeight: '600',
              textTransform: 'uppercase',
            }}
          >
            <RichText render={allPriceInfo.section1_header} />
          </div>
        </th>
        <th
          style={{ borderLeftWidth: '3rem', borderRightWidth: '3rem' }}
          class="w-1/5 brief5 py-5 px-6  text-center border-solid border-l-8 border-r-0 border-white  mx-2 center text-lg leading-6 font-medium text-gray-900 text-left"
          colspan="1"
          scope="colgroup"
        ></th>
        <th
          style={{ borderLeftWidth: '3rem', borderRightWidth: '3rem' }}
          class="w-1/5 brief5 py-5 px-6  text-center border-solid border-l-8 border-r-0 border-white  mx-2 center text-lg leading-6 font-medium text-gray-900 text-left"
          colspan="1"
          scope="colgroup"
        ></th>
        <th
          style={{ borderLeftWidth: '3rem', borderRightWidth: '3rem' }}
          class="w-1/5 brief5 py-5 px-6  text-center border-solid border-l-8 border-r-0 border-white  mx-2 center text-lg leading-6 font-medium text-gray-900 text-left"
          colspan="1"
          scope="colgroup"
        ></th>
      </tr>

      {features.map((feature, i) => {
        if (feature.subheader[0].text === section1) {
          return (
            <Line
              key={i}
              title={feature.pricing_table_feature_title}
              tooltip={feature.pricing_table_feature_title_tooltip}
              free={feature.pricing_table_package_1}
              freeText={feature.pricing_table_package_1_text}
              premium={feature.pricing_table_package_2}
              premiumText={feature.pricing_table_package_2_text}
              enterprise={feature.pricing_table_package_3}
              enterpriseText={feature.pricing_table_package_3_text}
              font="Inter400"
            />
          );
        }
      })}

      <tr>
        <th
          class=" py-3 pl-6 text-sm font-medium text-gray-900 text-left"
          colspan="1"
          scope="colgroup"
        >
          <div
            style={{
              fontFamily: 'Inter600',
              color: 'black',
              fontSize: '18px',
              fontWeight: '600',
              textTransform: 'uppercase',
            }}
          >
            <RichText render={allPriceInfo.section2_header} />
          </div>
        </th>
        <th
          style={{ borderLeftWidth: '3rem', borderRightWidth: '3rem' }}
          class="w-1/5 brief5 py-5 px-6  text-center border-solid border-l-8 border-r-0 border-white  mx-2 center text-lg leading-6 font-medium text-gray-900 text-left"
          colspan="1"
          scope="colgroup"
        ></th>
        <th
          style={{ borderLeftWidth: '3rem', borderRightWidth: '3rem' }}
          class="w-1/5 brief5 py-5 px-6  text-center border-solid border-l-8 border-r-0 border-white  mx-2 center text-lg leading-6 font-medium text-gray-900 text-left"
          colspan="1"
          scope="colgroup"
        ></th>
        <th
          style={{ borderLeftWidth: '3rem', borderRightWidth: '3rem' }}
          class="w-1/5 brief5 py-5 px-6  text-center border-solid border-l-8 border-r-0 border-white  mx-2 center text-lg leading-6 font-medium text-gray-900 text-left"
          colspan="1"
          scope="colgroup"
        ></th>
      </tr>

      {features.map((feature, i) => {
        if (feature.subheader[0].text === section2) {
          return (
            <Line
              key={i}
              title={feature.pricing_table_feature_title}
              tooltip={feature.pricing_table_feature_title_tooltip}
              free={feature.pricing_table_package_1}
              freeText={feature.pricing_table_package_1_text}
              premium={feature.pricing_table_package_2}
              premiumText={feature.pricing_table_package_2_text}
              enterprise={feature.pricing_table_package_3}
              enterpriseText={feature.pricing_table_package_3_text}
              font="Inter400"
            />
          );
        }
      })}

      <tr>
        <th
          class=" py-3 pl-6 text-sm font-medium text-gray-900 text-left"
          colspan="1"
          scope="colgroup"
        >
          <P
            style={{
              fontFamily: 'Inter600',
              color: 'black',
              fontSize: '18px',
              fontWeight: '600',
              textTransform: 'uppercase',
            }}
          >
            <RichText render={allPriceInfo.section3_header} />
          </P>
        </th>
        <th
          style={{ borderLeftWidth: '3rem', borderRightWidth: '3rem' }}
          class="w-1/5 brief5 py-5 px-6  text-center border-solid border-l-8 border-r-0 border-white  mx-2 center text-lg leading-6 font-medium text-gray-900 text-left"
          colspan="1"
          scope="colgroup"
        ></th>
        <th
          style={{ borderLeftWidth: '3rem', borderRightWidth: '3rem' }}
          class="w-1/5 brief5 py-5 px-6  text-center border-solid border-l-8 border-r-0 border-white  mx-2 center text-lg leading-6 font-medium text-gray-900 text-left"
          colspan="1"
          scope="colgroup"
        ></th>
        <th
          style={{ borderLeftWidth: '3rem', borderRightWidth: '3rem' }}
          class="w-1/5 brief5 py-5 px-6  text-center border-solid border-l-8 border-r-0 border-white  mx-2 center text-lg leading-6 font-medium text-gray-900 text-left"
          colspan="1"
          scope="colgroup"
        ></th>
      </tr>

      {features.map((feature, i) => {
        if (feature.subheader[0].text === section3) {
          return (
            <Line
              key={i}
              title={feature.pricing_table_feature_title}
              tooltip={feature.pricing_table_feature_title_tooltip}
              free={feature.pricing_table_package_1}
              freeText={feature.pricing_table_package_1_text}
              premium={feature.pricing_table_package_2}
              premiumText={feature.pricing_table_package_2_text}
              enterprise={feature.pricing_table_package_3}
              enterpriseText={feature.pricing_table_package_3_text}
              font="Inter400"
            />
          );
        }
      })}

      <tr>
        <th
          class=" py-3 pl-6 text-sm font-medium text-gray-900 text-left"
          colspan="1"
          scope="colgroup"
        >
          <P
            style={{
              fontFamily: 'Inter600',
              color: 'black',
              fontSize: '18px',
              fontWeight: '600',
              textTransform: 'uppercase',
            }}
          >
            <RichText render={allPriceInfo.section4_header} />
          </P>
        </th>
        <th
          style={{ borderLeftWidth: '3rem', borderRightWidth: '3rem' }}
          class="w-1/5 brief5 py-5 px-6  text-center border-solid border-l-8 border-r-0 border-white  mx-2 center text-lg leading-6 font-medium text-gray-900 text-left"
          colspan="1"
          scope="colgroup"
        ></th>
        <th
          style={{ borderLeftWidth: '3rem', borderRightWidth: '3rem' }}
          class="w-1/5 brief5 py-5 px-6  text-center border-solid border-l-8 border-r-0 border-white  mx-2 center text-lg leading-6 font-medium text-gray-900 text-left"
          colspan="1"
          scope="colgroup"
        ></th>
        <th
          style={{ borderLeftWidth: '3rem', borderRightWidth: '3rem' }}
          class="w-1/5 brief5 py-5 px-6  text-center border-solid border-l-8 border-r-0 border-white  mx-2 center text-lg leading-6 font-medium text-gray-900 text-left"
          colspan="1"
          scope="colgroup"
        ></th>
      </tr>

      {features.map((feature, i) => {
        if (feature.subheader[0].text === section4) {
          return (
            <Line
              key={i}
              title={feature.pricing_table_feature_title}
              tooltip={feature.pricing_table_feature_title_tooltip}
              free={feature.pricing_table_package_1}
              freeText={feature.pricing_table_package_1_text}
              premium={feature.pricing_table_package_2}
              premiumText={feature.pricing_table_package_2_text}
              enterprise={feature.pricing_table_package_3}
              enterpriseText={feature.pricing_table_package_3_text}
              font="Inter400"
            />
          );
        }
      })}

      <tr>
        <th
          class=" py-3 pl-6 text-sm font-medium text-gray-900 text-left"
          colspan="1"
          scope="colgroup"
        >
          <P
            style={{
              fontFamily: 'Inter600',
              color: 'black',
              fontSize: '18px',
              fontWeight: '600',
              textTransform: 'uppercase',
            }}
          >
            <RichText render={allPriceInfo.section5_header} />
          </P>
        </th>
        <th
          style={{ borderLeftWidth: '3rem', borderRightWidth: '3rem' }}
          class="w-1/5 brief5 py-5 px-6  text-center border-solid border-l-8 border-r-0 border-white  mx-2 center text-lg leading-6 font-medium text-gray-900 text-left"
          colspan="1"
          scope="colgroup"
        ></th>
        <th
          style={{ borderLeftWidth: '3rem', borderRightWidth: '3rem' }}
          class="w-1/5 brief5 py-5 px-6  text-center border-solid border-l-8 border-r-0 border-white  mx-2 center text-lg leading-6 font-medium text-gray-900 text-left"
          colspan="1"
          scope="colgroup"
        ></th>
        <th
          style={{ borderLeftWidth: '3rem', borderRightWidth: '3rem' }}
          class="w-1/5 brief5 py-5 px-6  text-center border-solid border-l-8 border-r-0 border-white  mx-2 center text-lg leading-6 font-medium text-gray-900 text-left"
          colspan="1"
          scope="colgroup"
        ></th>
      </tr>

      {features.map((feature, i) => {
        if (feature.subheader[0].text === section5) {
          return (
            <Line
              key={i}
              title={feature.pricing_table_feature_title}
              tooltip={feature.pricing_table_feature_title_tooltip}
              free={feature.pricing_table_package_1}
              freeText={feature.pricing_table_package_1_text}
              premium={feature.pricing_table_package_2}
              premiumText={feature.pricing_table_package_2_text}
              enterprise={feature.pricing_table_package_3}
              enterpriseText={feature.pricing_table_package_3_text}
              font="Inter400"
            />
          );
        }
      })}

      {features.map((feature, i) => {
        if (feature.subheader[0].text === section6) {
          return (
            <Line
              key={i}
              title={feature.pricing_table_feature_title}
              tooltip={feature.pricing_table_feature_title_tooltip}
              free={feature.pricing_table_package_1}
              freeText={feature.pricing_table_package_1_text}
              premium={feature.pricing_table_package_2}
              premiumText={feature.pricing_table_package_2_text}
              enterprise={feature.pricing_table_package_3}
              enterpriseText={feature.pricing_table_package_3_text}
              font="Inter600"
            />
          );
        }
      })}
    </tbody>
  );
};

export default PriceGrid;
